import { ref } from "vue";

// Module-level reactive state shared across the app
export const appUpdateRequired = ref(false);
